import { Slide } from "packages/lesson/dist/@types";

import { task as task01 } from "../../../../../task/course-01/lesson-20/task-01";

const task: Slide = {
  titleHtml:
    "Consider a parallelepiped cavity such that Lx = 10 m, Ly = 7 m, and Lz = 3 m.<br>Associate each mode indice with its frequency.",
  description: "Connect with lines.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
